(function ($, window, document, undefined) {

    "use strict";

    var pluginName = "sortable",
        defaults = {
            'baseurl': '',
            'args': {},
            'sortableAttribute': 'sortable',
            'sortRelationAttribute': 'sort-relation',
            'sortFieldAttribute': 'sort-field',
            'sortDirectionAttribute': 'sort-direction',
            'relationUrlArgumentName': 'sortRelation',
            'fieldUrlArgumentName': 'sortField',
            'directionUrlArgumentName': 'sortDirection'
        };

    function Plugin(element, options) {
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {
        init: function () {
            var Plugin = this;

            Plugin.setArgs();
            Plugin.setEvents();
        },

        setArgs: function () {
            var Plugin = this;

            Plugin.settings.baseurl = window.location.href.split('?').shift();

            if (!/\?/.test(window.location.href)) {
                return Plugin;
            }

            var existingArguments = window.location.href.split('?').pop().split('&');

            for (var i = 0; i < existingArguments.length; i++) {
                var newItem = existingArguments[i].split('=');
                Plugin.settings.args[newItem[0]] = newItem[1];
            }

            return Plugin;
        },

        /**
         * Ajoute les event listeners.
         * @returns {Plugin}
         */
        setEvents: function () {
            var Plugin = this;

            $(document).on('click', '[' + Plugin.settings.sortableAttribute + '] [' + Plugin.settings.sortFieldAttribute + '][' + Plugin.settings.sortDirectionAttribute + ']', function (e) {
                Plugin.sort(
                    e.currentTarget.getAttribute(Plugin.settings.sortFieldAttribute),
                    e.currentTarget.getAttribute(Plugin.settings.sortDirectionAttribute),
                    e.currentTarget.getAttribute(Plugin.settings.sortRelationAttribute),
                    $(e.currentTarget));
            });

            return Plugin;
        },

        /**
         * Evénement au survol de la grille.
         * @returns {Plugin}
         */
        sort: function (fieldname, direction, relation, $origin) {
            var Plugin = this,
                target = Plugin.settings.baseurl + '?';

            if ($origin.is('[ajax]')) {
                target = $origin.closest('.reveal').data('refresh').replace(/\?(.*)/, '');
                $(document).trigger('refreshModal', target + '?' + '&sortField=' + fieldname + '&sortDirection=' + direction);
                return Plugin;
            }

            Plugin.settings.args[Plugin.settings.fieldUrlArgumentName] = fieldname;
            Plugin.settings.args[Plugin.settings.directionUrlArgumentName] = direction;
            Plugin.settings.args[Plugin.settings.relationUrlArgumentName] = relation;

            for (var key in Plugin.settings.args) {
                if (Plugin.settings.args.hasOwnProperty(key) && Plugin.settings.args[key]) {
                    target += '&' + key + '=' + Plugin.settings.args[key];
                }
            }

            window.location = target.replace('?&', '?');

            return Plugin;
        }
    });

    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
    };

})(jQuery, window, document);